import { useEffect, useState } from 'react';
import { AdminService } from '../services';
import {
    getDefaultTipoIdentificacionCodigo,
    TipoIdentificacionItem,
} from '../utils/tiposIdentificacion';

export type { TipoIdentificacionItem };

export function useTiposIdentificacion() {
    const [tiposIdentificacion, setTiposIdentificacion] = useState<TipoIdentificacionItem[]>([]);
    const [isLoadingTipos, setIsLoadingTipos] = useState(true);

    useEffect(() => {
        const loadTiposIdentificacion = async () => {
            try {
                const tipos = await AdminService.getTiposIdentificacionList();
                setTiposIdentificacion(tipos);
            } finally {
                setIsLoadingTipos(false);
            }
        };
        loadTiposIdentificacion();
    }, []);

    const defaultTipoCodigo = getDefaultTipoIdentificacionCodigo(tiposIdentificacion);

    return { tiposIdentificacion, isLoadingTipos, defaultTipoCodigo };
};
